import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "@/content";
import { WinnerSeal } from "@/components/Brand";
import { Reveal } from "@/components/Motion";
import { V3Eyebrow, V3Title } from "@/sections/v3/shared";

// 10. Finalistes + Gagnants — diptyque : deux colonnes séparées par un filet vertical.
const Panel = ({ data, linkTo, linkLabel, seal = false, testid }) => (
  <div className="relative">
    {seal && (
      <div className="absolute end-0 top-0" aria-hidden="false">
        <WinnerSeal size={92} className="md:h-[110px] md:w-[110px]" />
      </div>
    )}
    <V3Eyebrow>{data.eyebrow}</V3Eyebrow>
    <V3Title testid={`${testid}-title`} className="max-w-md pe-24 md:text-[2rem]">{data.title}</V3Title>
    <Reveal delay={0.1}>
      <p className="mt-6 w-fit border border-copper/40 px-4 py-2 text-[0.75rem] uppercase tracking-[0.22em] text-blush" data-testid={`${testid}-status`}>
        {data.status}
      </p>
    </Reveal>
    <Reveal delay={0.12}>
      <p className="mt-6 max-w-lg text-[0.95rem] leading-relaxed text-white/80">{data.intro}</p>
    </Reveal>
    <Reveal delay={0.15}>
      <p className="mt-12 text-[0.75rem] uppercase tracking-[0.3em] text-copper">{data.listTitle}</p>
    </Reveal>
    <ol className="mt-5" data-testid={`${testid}-list`}>
      {data.items.map((it, i) => (
        <Reveal as="li" key={it.title} delay={Math.min(i * 0.04, 0.25)} className="border-t border-copper/20 py-4 last:border-b">
          <div className="flex items-baseline gap-4">
            <span className="w-7 shrink-0 font-sans text-[0.75rem] tabular-nums tracking-[0.18em] text-copper">{String(i + 1).padStart(2, "0")}</span>
            <div>
              <h3 className="text-[0.85rem] uppercase leading-relaxed tracking-[0.14em] text-white">{it.title}</h3>
              <p className="mt-1.5 text-[0.95rem] leading-relaxed text-white/70">{it.text}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </ol>
    <Reveal delay={0.1} className="mt-10">
      <Link to={linkTo} data-testid={`${testid}-link`} className="link-line text-[0.75rem] uppercase tracking-[0.3em] text-copper hover:text-blush">
        {linkLabel} <ArrowUpRight size={13} strokeWidth={1.4} className="mb-0.5 inline" />
      </Link>
    </Reveal>
    {data.nb && (
      <Reveal className="mt-10">
        <p className="text-[0.95rem] leading-relaxed text-white/60">{data.nb}</p>
      </Reveal>
    )}
  </div>
);

export const Selection3 = () => {
  const c = useContent();
  return (
    <section id="selection" data-testid="section-selection" className="text-white">
      <div className="grid lg:grid-cols-2">
        <div className="grain bg-[#141011] px-6 py-20 md:px-12 md:py-28 lg:border-e lg:border-copper/25 lg:px-14">
          <Panel data={c.finalists} linkTo="/finalistes" linkLabel={c.ui.seeFinalists} testid="finalists" />
        </div>
        <div className="grain bg-[#7A0F1A] px-6 py-20 md:px-12 md:py-28 lg:px-14">
          <Panel data={c.winners} linkTo="/gagnants" linkLabel={c.ui.seeWinners} seal testid="winners" />
        </div>
      </div>
    </section>
  );
};
